import React, { useState, Fragment, useEffect, createContext, useRef, useCallback } from 'react';
import { useForm, useFormContext, Controller, ErrorMessage } from 'react-hook-form';
import { useStyle } from './style';
import {
	Paper, Grid,
	TextField, FormControlLabel,
	Checkbox, FormLabel,
	Box, InputAdornment,
	Tooltip, IconButton,
	Typography, FormControl,
	Select, MenuItem, InputLabel
} from '@material-ui/core';
import HelpOutlinedIcon from '@material-ui/icons/HelpOutlined';
import { masterData } from './data';
import errormesages from './errormessages';
export default function EirContactDetails(props) {
	const { register, errors, control, setError, setValue, getValues, clearError } = useFormContext();
	const { validation } = errormesages;
	const classes = useStyle();
	const emailInputRef = useRef();
	const confEmailInputRef = useRef();
	const mobileInputRef = useRef();
	const titleInputRef = useRef();
	const preContactInputRef = useRef();
	const mailConfirmation = props.mailConfirmation;
	const loginSuccessStatus = props.loginSuccess;
	const [firstName, setFirstName] = useState(null);
	const [lastName, setLastName] = useState(null);
	const [email, setEmail] = useState(null);
	const [emailConfirm, setEmailConfirm] = useState(null);
	
	const validateEmailConfirmation = (value) => {
		return value == getValues('email')
	}

	useEffect(() => {
		if (loginSuccessStatus || (sessionStorage.getItem("existingCustomerDetails") && (JSON.parse(sessionStorage.getItem("existingCustomerDetails")).data.portalUser.firstName))) {
			setFirstName(JSON.parse(sessionStorage.getItem("existingCustomerDetails")).data.portalUser.firstName);
			if (firstName != null) {
				setValue('firstName', firstName, { shouldDirty: true });    //setting updated values to textfields for existing customers on login
			}
		}
	}, [loginSuccessStatus, firstName]);

	useEffect(() => {
		if (loginSuccessStatus || (sessionStorage.getItem("existingCustomerDetails") && (JSON.parse(sessionStorage.getItem("existingCustomerDetails")).data.portalUser.surname))) {
			setLastName(JSON.parse(sessionStorage.getItem("existingCustomerDetails")).data.portalUser.surname);
			if (lastName != null) {
				setValue('lastName', lastName, { shouldDirty: true });   //setting updated values to textfields for existing customers on login
			}
		}
	}, [loginSuccessStatus, lastName]);

	useEffect(() => {
		if (loginSuccessStatus || (sessionStorage.getItem("existingCustomerDetails") && (JSON.parse(sessionStorage.getItem("existingCustomerDetails")).data.portalUser.emailAddress))) {
			setEmail(JSON.parse(sessionStorage.getItem("existingCustomerDetails")).data.portalUser.emailAddress);
			if (email != null) {
				setValue('email', email, { shouldDirty: true });   //setting updated values to textfields for existing customers on login
			}
		}
	}, [loginSuccessStatus, email]);

	useEffect(() => {
		if (loginSuccessStatus || (sessionStorage.getItem("existingCustomerDetails") && (JSON.parse(sessionStorage.getItem("existingCustomerDetails")).data.portalUser.emailAddress))) {
			setEmailConfirm(JSON.parse(sessionStorage.getItem("existingCustomerDetails")).data.portalUser.emailAddress);
			if (emailConfirm != null) {
				setValue('confEmail', emailConfirm, { shouldDirty: true });   //setting updated values to textfields for existing customers on login
			}
		}
	}, [loginSuccessStatus, emailConfirm]);

	useEffect(() => {
		if (!mailConfirmation) {
			setError('confEmail', 'manual', validation.confirmEmailAddressError);
		}
	}, [mailConfirmation]);
	return (
		<Fragment>
			<Grid item sm={12} className={classes.contactPadding}>
				<Paper className={classes.contactPaper} variant='elevation' elevation={4}>
					<Grid container>
						<Grid item sm={6}>
							<Grid container>
								<Grid item sm={7}>
									<h2 className={classes.contactTxt}>
										Contact Information
									</h2 >
								</Grid>
								<Grid item sm={5}>
									<Tooltip
										enterTouchDelay={20}
										leaveTouchDelay={15000}
										title="Please Note: The name you enter here must match the name of the bank account holder you will enter later."
										placement='right'>
										<HelpOutlinedIcon
											style={{ color: '#892BA0', marginTop: '10px', marginLeft: '-2rem' }}
											className={classes.questionIcon}
										/>
									</Tooltip>
								</Grid>
							</Grid>
						</Grid>
						<Grid item sm={6} xs={12}>
							<Typography className={classes.reqText}><span style={{ color: 'red', textAlign: 'center' }} >*</span> Required Fields</Typography>
						</Grid>
					</Grid>
					<Grid container sm={12} xs={12} className={classes.gridDownSpace}>
						<Grid item sm={3} xs={6}>
							<FormControl variant="outlined" fullWidth size="small" color="secondary">
								<InputLabel required
									error={Boolean(errors.title)}
								>Title</InputLabel>
								<Controller
									control={control}
									name="title"
									id="title"
									inputRef={titleInputRef}
									defaultValue=""
									error={Boolean(errors.title)}
									onFocus={() => {
										titleInputRef.current.focus();
									}}
									rules={{ required: { value: true, message: validation.titleRequired } }}
									as={
										<Select
											id="title"
											label="Title"
										>
											{masterData.filter(masterData => masterData.id === 'title').map((data) =>
												data.value.map((val) =>
												(
													<MenuItem key={val.value} value={val.value} className={classes.selectLabel}>
														{val.label}
													</MenuItem>
												))
											)}
										</Select>
									}
								/>
								<Grid className={classes.errorMessageHeight}>
									<ErrorMessage errors={errors} name='title'>
										{({ message }) => <p className={classes.errorMessage}>{message}</p>}
									</ErrorMessage>
								</Grid>
							</FormControl>
						</Grid>
					</Grid>
					<Grid container sm={12} xs={12}
					>
						<Grid item sm={6} xs={12} className={classes.paddingRightItem}>
							<Controller
								as={<TextField color="secondary" />}
								inputRef={register}
								control={control}
								fullWidth
								id="firstName"
								name="firstName"
								label="First name"
								variant="outlined"
								size="small"
								error={Boolean(errors.firstName)}
								onFocus={() => {
									titleInputRef.current.focus();
								}}
								InputLabelProps={(firstName) && { shrink: true }}
								required

								rules={{
									required: { value: true, message: validation.firstnameRequired },
									minLength: { value: 2, message: validation.nameMinLength },
									maxLength: { value: 100, message: validation.nameMaxLength },
									pattern: { value: /^([^0-9]*)$/, message: validation.firstNamePattern }
								}}
							/>
							<Grid className={classes.errorMessageHeight}>
								<ErrorMessage errors={errors} name="firstName">
									{({ message }) => <p className={classes.errorMessage}>{message}</p>}
								</ErrorMessage>
							</Grid>
						</Grid>
						<Grid item sm={6} xs={12} className={classes.paddingLeftItem}>
							<Controller
								as={<TextField color="secondary" />}
								inputRef={register}
								control={control}
								fullWidth
								id="lastName"
								name="lastName"
								label="Last name"
								variant="outlined"
								size="small"
								error={Boolean(errors.lastName)}
								onFocus={() => {
									titleInputRef.current.focus();
								}}
								InputLabelProps={(lastName) && { shrink: true }}
								required

								rules={{
									required: { value: true, message: validation.lastNameRequired },
									minLength: { value: 2, message: validation.nameMinLength },
									maxLength: { value: 100, message: validation.nameMaxLength },
									pattern: { value: /^([^0-9]*)$/, message: validation.lastNamePattern }
								}}
							/>
							<Grid className={classes.errorMessageHeight}>
								<ErrorMessage errors={errors} name="lastName">
									{({ message }) => <p className={classes.errorMessage}>{message}</p>}
								</ErrorMessage>
							</Grid>
						</Grid>
					</Grid>
					<Grid container sm={12} xs={12}
					>
						<Grid item sm={6} xs={12} className={classes.paddingRightItem}>
							<Controller
								as={<TextField color="secondary" />}
								inputRef={register}
								control={control}
								fullWidth
								id="email"
								name="email"
								label="Email address"
								variant="outlined"
								size="small"
								error={Boolean(errors.email)}
								onFocus={() => {
									titleInputRef.current.focus();
								}}
								InputLabelProps={(email) && { shrink: true }}
								required
								rules={{
									required: { value: true, message: validation.emailAddressRequired },
									pattern: { value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, message: validation.emailAddressError }
								}}
							/>
							<Grid className={classes.errorMessageHeight}>
								<ErrorMessage errors={errors} name="email">
									{({ message }) => <p className={classes.errorMessage}>{message}</p>}
								</ErrorMessage>
							</Grid>
						</Grid>
						<Grid item sm={6} xs={12} className={classes.paddingLeftItem}>
							<Controller
								as={<TextField color="secondary" />}
								inputRef={register}
								control={control}
								fullWidth
								id="confEmail"
								name="confEmail"
								label="Email confirmation"
								variant="outlined"
								size="small"
								InputLabelProps={(emailConfirm) && { shrink: true }}
								error={Boolean(errors.confEmail)}
								onFocus={() => {
									titleInputRef.current.focus();
								}}
								
								required
								rules={{
									required: { value: true, message: validation.confirmEmailAddressRequired },
									validate: {validateEmailConfirmation}
								}}
							/>
							<Grid className={classes.errorMessageHeight}>
								{errors && errors.confEmail && errors.confEmail.type == 'validateEmailConfirmation' ? 
								<ErrorMessage errors={errors} name="confEmail">
									{({message}) => <p className={classes.errorMessage}>{validation.confirmEmailAddressError}</p>}
								</ErrorMessage> 
								: <ErrorMessage errors={errors} name="confEmail">
									{({message}) => <p className={classes.errorMessage}>{message}</p>}
								</ErrorMessage>}
							</Grid>
						</Grid>
					</Grid>
					<Grid container sm={12} xs={12}>
						<Grid item sm={6} xs={12} className={classes.paddingRightItem}>
							<Controller
								as={<TextField inputRef={mobileInputRef} color="secondary" />}
								control={control}
								fullWidth
								id="mobile"
								name="mobile"
								label="Mobile number"
								variant="outlined"
								size="small"
								error={Boolean(errors.mobile)}
								required
								onFocus={() => {
									mobileInputRef.current.focus();
								}}
								rules={{
									required: { value: true, message: validation.mobileNumberRequired },
									pattern: { value: /^08[0-9]{8}$/, message: validation.mobileNumberPattern }
								}}
							/>

							<ErrorMessage errors={errors} name="mobile">
								{({ message }) => <p className={classes.errorMessage}>{message}</p>}
							</ErrorMessage>

							<p className={classes.mobileInfoTip}>This number will be used to contact you in relation to your order</p>
						</Grid>
						<Grid item sm={6} xs={12} className={classes.paddingLeftItem}>
							<FormControl variant="outlined" fullWidth size="small" color="secondary">
								<InputLabel required
									error={Boolean(errors.preContact)}>Preferred contact for order updates</InputLabel>
								<Controller
									control={control}
									name="preContact"
									id="preContact"
									inputRef={preContactInputRef}
									defaultValue=""
									rules={{ required: { value: true, message: validation.preContactRequired } }}
									error={Boolean(errors.preContact)}
									onFocus={() => {
										preContactInputRef.current.focus();
									}}
									as={
										<Select
											id="preContact"
											label="Preferred contact for order updates "
										>
											{masterData.filter(masterData => masterData.id === 'contactPreference').map((data) =>
												data.value.map((val) =>
												(
													<MenuItem key={val.value} value={val.value} className={classes.selectLabel}>
														{val.label}
													</MenuItem>
												))
											)}
										</Select>
									}
								/>
								<ErrorMessage errors={errors} name="preContact">
									{({ message }) => <p className={classes.errorMessage}>{message}</p>}
								</ErrorMessage>
							</FormControl>
						</Grid>
					</Grid>
				</Paper>
			</Grid>
		</Fragment>
	);
}